import { useState } from "react";
import { Link } from "react-router-dom";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");

  async function handleReset(e) {
    e.preventDefault();
    try {
      // TODO: call API forgot password
      alert("Đã gửi hướng dẫn đặt lại mật khẩu vào email");
    } catch {
      alert("Lỗi, vui lòng thử lại");
    }
  }

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <div className="card shadow-sm p-4" style={{ width: "380px", borderRadius: "12px" }}>
        <h3 className="text-center mb-3">Quên mật khẩu</h3>

        <form onSubmit={handleReset}>
          <div className="mb-3">
            <label>Email</label>
            <input
              className="form-control"
              placeholder="Nhập email để đặt lại mật khẩu"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button className="btn btn-warning w-100">Gửi yêu cầu</button>

          <div className="text-center mt-3">
            <Link to="/login" className="text-decoration-none">
              Quay lại đăng nhập
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
